import React from 'react'
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'
import { Link } from 'react-router-dom';

const ChatChannelList = props => {
  if (!props.channels) {
    return (
      <div className='broad'>Loading...</div>
    );
  }

  if (props.channels.length === 0) {
    return (
      <div className='empty'>
        No channels...
      </div>
    );
  }

  return (
    <div>
      <table className="dataTable">
        <thead>
          <tr>
            <th>Key</th>
            <th>Title</th>
            <th>Language</th>
            <th>userkey</th>
            <th>Created</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            props.channels.map(item => {
              return (
                <tr key={item.key}>
                  <td className="keyfield"><Link to={`/channels/${item.key}`}>{item.key}</Link></td>
                  <td>{item.title}</td>
                  <td>{item.language}</td>
                  <td>{item.userkey}</td>
                  <td>{dateHelper.Formatter.toLocalString(item.created)}</td>
                  <td className="keyfield"><Link to={`/channels/${item.key}/edit`}>Edit</Link></td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  );
};

export default ChatChannelList;



// WEBPACK FOOTER //
// ./src/components/widgets/ChatChannelList.js